export const routes = [
  {
    path: '/navigator/scenarios',
    name: 'Scenarios',
    component: () => import('../views/Scenarios.vue'),
  },
  {
    path: '/navigator/scenarios/edit/:id',
    name: 'ScenarioCard',
    component: () => import('../views/ScenarioCard.vue'),
  },
  {
    path: '/navigator/stages',
    name: 'Stages',
    component: () => import('../views/Stages.vue'),
  },
  {
    path: '/navigator/stages/edit/:id',
    name: 'StageCard',
    component: () => import('../views/StageCard.vue'),
  },
  {
    path: '/navigator/procedures',
    name: 'Procedures',
    component: () => import('../views/Procedures.vue'),
  },
  {
    path: '/navigator/procedures/edit/:id',
    name: 'ProcedureCard',
    component: () => import('../views/ProcedureCard.vue'),
  },
  {
    path: '/navigator/steps',
    name: 'Steps',
    component: () => import('../views/Steps.vue'),
  },
  {
    path: '/navigator/steps/edit/:id',
    name: 'StepCard',
    component: () => import('../views/StepCard.vue'),
  },
  {
    path: '/navigator/documents',
    name: 'NavigatorDocuments',
    component: () => import('../views/Documents.vue'),
  },
  {
    path: '/navigator/documents/edit/:id',
    name: 'NavigatorDocumentCard',
    component: () => import('../views/DocumentCard.vue'),
  },
  {
    path: '/navigator/legalsources',
    name: 'LegalSources',
    component: () => import('../views/LegalSources.vue'),
  },
  {
    path: '/navigator/legalsources/edit/:id',
    name: 'LegalSourceCard',
    component: () => import('../views/LegalSourceCard.vue'),
  },
  {
    path: '/navigator/organizations',
    name: 'NavOrgs',
    component: () => import('@/modules/admin/views/OrganizationsPage.vue'),
  },
  {
    path: '/navigator/organizations/:action/:id',
    name: 'NavOrgCard',
    component: () => import('@/modules/admin/views/OrganizationCard.vue'),
  },
  {
    path: '/navigator/registry',
    name: 'NavigatorRegistry',
    component: () => import('../views/Registry.vue'),
  },
  {
    path: '/navigator/registry/:action/:id',
    name: 'NavigatorRegistryCard',
    component: () => import('../views/RegistryCard.vue'),
  },
  {
    path: '/navigator/stepActions',
    name: 'StepActions',
    component: () => import('../views/StepActions.vue'),
  },
  {
    path: '/navigator/product-groups',
    name: 'ProductGroups',
    component: () => import('../views/ProductGroups.vue'),
  },
  {
    path: '/navigator/product-groups/:id/:type',
    name: 'ProductGroupsCard',
    component: () => import('../views/ProductGroupsCard.vue'),
  },
];
